var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.routed)?_c('div',{staticClass:"h-100 w-100"},[_c('AnimateIcon',{attrs:{"type":"success"}},[_vm._v(_vm._s(_vm.meg))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }